export default __webpack_public_path__ + "static/media/experiment-card.899d1af6.svg";